import { c as _c } from "react/compiler-runtime";
import { VStack } from "@navikt/ds-react";
import { HeadingLeder } from "@/shared/components/HeadingLeder";
import BehovForm from "./BehovForm";
import OppgiLederPanel from "./OppgiLederPanel";
import SykmeldtBox from "./SykmeldtBox";
export function EditView() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <VStack gap="space-32"><HeadingLeder /><OppgiLederPanel /><SykmeldtBox /><BehovForm /></VStack>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}